import { CardContainer } from 'layout/Card';
import CardContainerTitleSeeAll from 'layout/Card/CardContainer/CardContainerTitleSeeAll';
import { OrganizationAnomaliesTable } from 'pages/OrganizationViewPage/tables/OrganizationAnomaliesTable';
import OrganizationProjectsTable from 'pages/OrganizationViewPage/tables/OrganizationProjectsTable/OrganizationProjectsTable';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

const OrganizationAnomaliesAndProjects: FC = () => {
  const { t } = useTranslation();
  return (
    <div className="flex gap-4">
      <div className="flex-1 w-1/2">
        <CardContainerTitleSeeAll
          title={t('organizationView.anomaliesAndProjects.titles.anomalies')}
          redirect="/app/operations/anomalies"
        />
        <CardContainer>
          <OrganizationAnomaliesTable />
        </CardContainer>
      </div>
      <div className="flex-1 w-1/2">
        <CardContainerTitleSeeAll
          title={t('organizationView.anomaliesAndProjects.titles.projects')}
          redirect="/app/management/projects"
        />
        <CardContainer>
          <OrganizationProjectsTable />
        </CardContainer>
      </div>
    </div>
  );
};
export default OrganizationAnomaliesAndProjects;
